import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import ProCard from '@ant-design/pro-card';
import ProDescriptions from '@ant-design/pro-descriptions';
import { Badge, Divider, Tabs } from 'antd';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';
import './index.less';
const useStyles = createUseStyles({
    agencyCard: {
        '&:hover': {
            backgroundColor: '#FAFAFA',
        },
        // padding: 8,
        // marginBottom: 16,
    },
    tabs: {
        '&.ant-tabs-nav': {
            marginLeft: '24px !important',
            marginBottom: '0px !important',
        }
    }
});
export const renderBadge = (count, active = false) => {
    return (_jsx(Badge, { count: count, style: {
            marginTop: -2,
            marginLeft: 4,
            color: active ? 'var( --lj-primary-color )' : '#999',
            backgroundColor: active ? '#E6F7FF' : '#eee',
        } }));
};
export const Agency = ({ title, extra, columns, dataSource, onChange, tabs, onClick, }) => {
    const defaultTabActiveKey = tabs?.[0].key;
    const [activeKey, setActiveKey] = useState(defaultTabActiveKey);
    const styles = useStyles();
    return (_jsx(ProCard, { title: title, extra: extra, bodyStyle: { padding: '24px 0px' }, children: _jsx(Tabs, { defaultActiveKey: defaultTabActiveKey, onChange: (key) => {
                setActiveKey(key);
                onChange?.(key);
            }, className: 'agency-tab', children: tabs?.map(({ badge, key, title: _title }) => {
                return (_jsx(Tabs.TabPane, { tab: _jsxs("span", { children: [_title, renderBadge(badge ?? 0, activeKey === key)] }), children: dataSource?.map(({ id, link, title: pTitle, ...rest }, index) => {
                        return (_jsxs(React.Fragment, { children: [link ? (_jsx(Link, { to: link, children: _jsx(ProDescriptions, { className: styles.agencyCard, title: pTitle, column: 1, size: "small", dataSource: rest, columns: columns, style: { padding: '24px' } }) })) : (_jsx("div", { onClick: onClick, style: { cursor: 'pointer' }, children: _jsx(ProDescriptions, { className: styles.agencyCard, title: pTitle, column: 1, size: "small", dataSource: rest, columns: columns, style: { padding: '24px' } }) })), dataSource?.length === index + 1 ? null : _jsx(Divider, { style: { margin: 0 } })] }, id));
                    }) }, key));
            }) }) }));
};
